import React, { ReactNode } from 'react'
import { useTheme } from 'src/ui/style/useTheme'
import { View } from 'src/ui/basic/View'
import { verticalChildSpacing } from 'src/ui/style/mixins/layout'
import { css } from 'src/ui/style/css'
import { Heading } from 'src/ui/text/Heading'
import { Divider } from 'src/ui/Divider'

export const FooterColumn = ({
    title,
    children
}: {
    title?: string
    children: ReactNode
}) => {
    const th = useTheme()
    return (
        <View
            css={[
                verticalChildSpacing(th.spacing.md)(th),
                css`
                    // Alings children to left and itself to top of parent
                    // (because of divider it has to be explicitly set here)
                    align-self: flex-start;
                    align-items: flex-start;
                `
            ]}
        >
            {title && (
                <View>
                    <Heading
                        level={3}
                        css={css`
                            text-transform: uppercase;
                            margin-bottom: ${th.spacing.sm};
                        `}
                    >
                        {title}
                    </Heading>
                    <Divider />
                </View>
            )}
            <View css={verticalChildSpacing(th.spacing.md)}>{children}</View>
        </View>
    )
}
